import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { TarlV3ApiModule } from '../tarl-v3-api';

import { TarlV3Jsonapi } from './tarl-v3-jsonapi.service';

@NgModule({
  imports: [CommonModule, HttpClientModule, TarlV3ApiModule],
  providers: [TarlV3Jsonapi],
})
export class TarlV3JsonapiModule {}
